/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Insights_SummaryInputs */

const en_why_listening_insights_summary = /** @type {(inputs: Why_Listening_Insights_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Links sleep spindle activity to how well students recall word lists the next morning, and tracks how the link changes with age.`)
};

const es_why_listening_insights_summary = /** @type {(inputs: Why_Listening_Insights_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relaciona la actividad de los husos del sueño con lo bien que los estudiantes recuerdan listas de palabras a la mañana siguiente, y sigue cómo cambia esa relación con la edad.`)
};

/**
* | output |
* | --- |
* | "Links sleep spindle activity to how well students recall word lists the next morning, and tracks how the link changes with age." |
*
* @param {Why_Listening_Insights_SummaryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_insights_summary = /** @type {((inputs?: Why_Listening_Insights_SummaryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Insights_SummaryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_insights_summary(inputs)
	return en_why_listening_insights_summary(inputs)
});